import { ApmService } from '@elastic/apm-rum-angular';
import { environment } from './environments/environment';

export function initApm(apm: ApmService) {
    return () => {

        const serviceName = environment.isSuperAdmin 
            ? 'sadatafill-signpl-angular'
            : 'datafill-signpl-angular';

        const apmInstance = apm.init({
            serviceName: serviceName,
            serverUrl: 'https://apm.signpl.com',
            environment: environment.production ? 'production' : 'development',
            transactionSampleRate: 0.2,
            distributedTracingOrigins: buildDistributedTracingOrigins(),
            propagateTracestate: true,
            logLevel: 'error',
        });

        // Redact sensitive keys from any APM payload before it is sent to Elastic.
        apmInstance.addFilter((payload) => redactSensitiveFields(payload));
    };
}

function buildDistributedTracingOrigins(): string[] {
    const origins = new Set<string>();

    [environment.apiURL, environment.blazzerUrl, environment.formVizzurl].forEach((url) => {
        const origin = getOrigin(url);

        if (origin) {
            origins.add(origin);
        }
    });

    return [...origins];
}

function getOrigin(url: string | undefined): string | null {
    if (!url) {
        return null;
    }

    try {
        return new URL(url).origin;
    } catch {
        return null;
    }
}

function redactSensitiveFields<T>(value: T): T {
    if (Array.isArray(value)) {
        return value.map((item) => redactSensitiveFields(item)) as T;
    }

    if (value && typeof value === 'object') {
        const source = value as Record<string, unknown>;
        const redacted: Record<string, unknown> = {};

        Object.entries(source).forEach(([key, currentValue]) => {
            redacted[key] = isSensitiveKey(key)
                ? '[REDACTED]'
                : redactSensitiveFields(currentValue);
        });

        return redacted as T;
    }

    return value;
}

function isSensitiveKey(key: string): boolean {
    return /pass(word)?|pwd|token|secret|authorization|auth|api[-_]?key|access[-_]?token|refresh[-_]?token|session|cookie/i.test(key);
}